export default __webpack_public_path__ + "static/media/Pulled Jackfruit Burger - proportioned_170.dea114da.jpg";